import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

export const InitializeToastSystem = () => {
	return <StyledContainer limit={3} autoClose={3000} style={{ zIndex: 9999999 }} />;
};

const StyledContainer = styled(ToastContainer)`
	.Toastify__toast {
		cursor: unset;
		&--info {
			border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
			background-color: ${({ theme }) => theme.v2.color.neutral[100]};
		}
		&--success {
			border: 1px solid ${({ theme }) => theme.v2.color.success[800]};
			background: linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
				${({ theme }) => theme.v2.color.success[600]};
		}
		&--warning {
			border: 1px solid ${({ theme }) => theme.v2.color.warning[600]};
			background: linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
				${({ theme }) => theme.v2.color.warning[600]};
		}
		&--error {
			border: 1px solid ${({ theme }) => theme.v2.color.error[600]};
			background: linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
				${({ theme }) => theme.v2.color.error[600]};
		}
	}

	.Toastify__progress-bar {
		animation-direction: reverse;
	}
`;
